import { isPlatformBrowser } from "@angular/common";
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import Glide from "@glidejs/glide";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE, WINDOW } from "@ng-toolkit/universal";
import * as $ from "jquery";
import { AppComponent } from "src/app/app.component";
import { CookiesService } from "src/app/services/cookies.service";
import { RestService } from "src/app/services/rest.service";
import { ServiceSEOService } from "src/app/services/service-seo.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit, AfterViewInit {
  @ViewChild("content", { static: false }) private content;
  @ViewChild("immigrationContent", { static: false })
  private immigrationContent;

  webDefaultLang: string = environment.defaultLang;
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private seo: ServiceSEOService,
    private modalService: NgbModal,
    private rest: RestService,
    private route: ActivatedRoute,
    private router: Router,
    public app: AppComponent,
    private cookie: CookiesService,
  ) {
    this.seo.addMetaTags();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $(document).ready(() => {
        new Glide("#jsCheckeVisaSlider", {
          type: "carousel",
          autoplay: 4000,
          gap: 0,
        }).mount();
        new Glide("#jsInformationSlider", {
          type: "carousel",
          perView: 4,
          gap: 1,
          breakpoints: {
            800: {
              perView: 1,
            },
          },
        }).mount();
      });

      this.route.paramMap.subscribe((result) => {
        const partner_id = result.get('partner_id') || 0;
        if (partner_id) {
          if (!this.cookie.getCookie("P_ID")) {
            this.rest.save_partner_access(partner_id).subscribe((rs) => {
              if (rs.status === "success") {
                this.cookie.setCookie("P_ID", partner_id, 1);
                window.location.href = "/index";
              } else {
                window.location.href = "/index";
              }
            });
          } else {
            window.location.href = "/index";
          }
        }
      });

      const script = document.createElement("script");
      script.src =
        "https://seal.geotrust.com/getgeotrustsslseal?host_name=www.laoevisa.gov.la&size=M&lang=en";
      script.async = true;
      const sitelockContainer = document.getElementById("sitelock-badge-container");
      if (sitelockContainer) {
        sitelockContainer.appendChild(script);
      }
    }
  }
  openLg(content) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.modalService
      .open(content, {
        size: "lg",
        centered: true,
        windowClass: "app-session-modal-window",
        backdropClass: "app-session-modal-backdrop",
      })
      .result.then(
        (result) => {
          // this.localStorage.setItem('viewAnnounce', 'yes');
          // console.log('result: ' + result);
          console.log("result: " + result);
          // if (result === "Close click") {
          //   this.openImmigrtionLg(this.immigrationContent);
          // }
        },
        (reason) => {
          // this.localStorage.setItem('viewAnnounce', 'yes');
          // console.log(reason);
        },
      );
  }

  openImmigrtionLg(immigrationContent) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.modalService
      .open(immigrationContent, {
        size: "lg",
        centered: true,
        windowClass: "app-session-modal-window",
        backdropClass: "app-session-modal-backdrop",
      })
      .result.then(
        (result) => {
          // this.localStorage.setItem('viewAnnounce', 'yes');
        },
        (reason) => {
          // this.localStorage.setItem('viewAnnounce', 'yes');
          // console.log(reason);
        },
      );
  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.openLg(this.content);
      });
    }
  }
  onActivate(event) {
    // this.window.scroll(0, 0);
    // or document.body.scrollTop = 0;
    // or document.querySelector('body').scrollTo(0,0)
  }
  openSiteLock(event: Event): void {
    event.preventDefault(); // Prevent the default anchor behavior
    window.open(
      "https://www.sitelock.com/verify.php?site=laoevisa.gov.la",
      "SiteLock",
      "width=600,height=600,left=160,top=170",
    );
  }
}
